// extracted by css-extract-rspack-plugin
export default {"label":"wf4CHrOnewY9E2pa","logos":"YObvllvt2Gcmok02","item":"bpHg7ZOCQ8EEeNkc"};